import { useState } from 'react';

function TransformedImage({ imageUrl, selectedStyle, onTryAnother }) {
  const [isImageLoading, setIsImageLoading] = useState(true);
  const [downloadStarted, setDownloadStarted] = useState(false);

  const handleDownload = () => {
    console.log('Downloading...', imageUrl);
    if (imageUrl) {
      setDownloadStarted(true);
      setTimeout(() => setDownloadStarted(false), 2000); // Reset download status after 2 seconds
      
      const link = document.createElement('a');
      link.href = imageUrl;
      link.download = `cartoon-pfp-${selectedStyle?.toLowerCase().replace(/\s+/g, '-') || 'image'}.png`;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  return (
    <section className="w-full max-w-md text-center bg-white p-4 rounded-lg shadow-sm">
      <h2 className="text-lg font-semibold mb-3 text-gray-700">Your Cartoon PFP!</h2>
      
      <div className="w-full max-w-xs h-auto aspect-square bg-gray-200 mx-auto mb-3 rounded overflow-hidden flex items-center justify-center text-gray-400 shadow-inner relative">
        {isImageLoading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 bg-opacity-75 z-10">
            <svg className="animate-spin h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
          </div>
        )}
        
        <img 
          src={imageUrl} 
          alt={`Transformed PFP - ${selectedStyle}`}
          className="w-full h-full object-contain"
          onLoad={() => setIsImageLoading(false)}
          onError={() => setIsImageLoading(false)}
        />
      </div>

      <div className="flex flex-col sm:flex-row justify-center items-center gap-2">
        <button
          onClick={handleDownload}
          className={`group bg-accent text-gray-800 font-medium py-1.5 px-4 rounded hover:bg-yellow-400 transition duration-200 flex items-center justify-center text-sm ${
            downloadStarted ? 'bg-green-500 text-white' : ''
          }`}
        >
          {downloadStarted ? (
            <>
              <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
              </svg>
              Downloaded!
            </>
          ) : (
            <>
              <svg className="h-4 w-4 mr-1 group-hover:animate-bounce" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Download
            </>
          )}
        </button>
        <button
          onClick={onTryAnother}
          className="text-secondary underline hover:text-blue-700 text-sm flex items-center justify-center"
        >
          <svg className="h-4 w-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M11 15l-3-3m0 0l3-3m-3 3h8M3 12a9 9 0 1118 0 9 9 0 01-18 0z" />
          </svg>
          Try Another
        </button>
      </div>
    </section>
  );
}

export default TransformedImage; 